export default __webpack_public_path__ + "static/media/evenShotBg.533bf6e9.png";